import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "bootstrap-icons/font/bootstrap-icons.css";

const jobData = [
  { title: "Senior  Developer", location: "Kanthansavadi,Chennai", salary: " $ 30,000 - 35,000 / month", exp: "2 years of experience" },
  { title: "Junior PHP Developer", location: "Kanthansavadi,Chennai", salary: "$ 20,000 - 25,000 / month", exp: "3 years of experience" },
  { title: "Network Engineer", location: "Kanthansavadi,Chennai", salary: "$ 30,000 - 35,000 / month", exp: "1 years of experience" },
  { title: "React Developer", location: "Kanthansavadi,Chennai", salary: "$ 28,000 - 32,000 / month", exp: "3 years of experience" },
  { title: "React Senior Developer", location: "Kanthansavadi,Chennai", salary: "$ 32,000 - 36,000 / month", exp: "7 years of experience" },
  { title: "Devops Engineer", location: "Kanthansavadi,Chennai", salary: "$ 25,000 - 35,000 / month", exp: "6 years of experience" },
  { title: "Android Developer", location: "Kanthansavadi,Chennai", salary: "$ 28,000 - 32,000 / month", exp: "5 years of experience" },
  { title: "HTML Developer", location: "Kanthansavadi,Chennai", salary: "$ 25,000 - 28,000 / month", exp: "3 years of experience" },
  { title: "UI/UX Designer", location: "Kanthansavadi,Chennai", salary: "$ 20,000 - 25,000 / month", exp: "3 years of experience" }
];

export default function EmployeeJobs() {
  const [selectedJob, setSelectedJob] = useState("");

  return (
    <div className="container-fluid p-4" style={{ background: "#f4f6fb" }}>
      <h5 className="mb-4 fw-bold">Jobs</h5>

      <div className="row">
        {jobData.map((job, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}>

              {/* TOP TITLE BAR */}
              <div
                style={{
                  background: "#f1f1f1",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  padding: "10px 15px"
                }}
              >
                <div className="d-flex align-items-center">

                  {/* ICON */}
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#e4e6eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "10px"
                    }}
                  >
                    <i className="bi bi-people" style={{ fontSize: "16px", color: "#555" }}></i>
                  </div>

                  {/* TEXT */}
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: "600" }}>
                      {job.title}
                    </div>
                    <div style={{ fontSize: "11px", color: "#0c0c0c" }}>
                      25 Applicants
                    </div>
                  </div>  

                </div>
              </div>

              {/* BODY */}
              <div className="card-body" style={{ fontSize: "13px" }}>
                <div className="mb-2">📍 {job.location}</div>
                <div className="mb-2">💲 {job.salary}</div>
                <div className="mb-3">👤 {job.exp}</div>

                {/* TAGS */}
                <div className="mb-2">
                  <span className="badge border border-danger  text-danger me-2" style={{ fontSize: "10px" }}>Full Time</span>
                  <span className="badge border border-secondary    text-dark " style={{ fontSize: "10px" }}>Expert</span>
                </div>

                {/* PROGRESS BAR */}
                <div className="progress custom-progress">
                  <div className="progress-bar custom-bar"></div>
                </div>
              </div>

              {/* APPLY BUTTON */}
              <div className="p-3">
                <button
                  className="btn btn-outline-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#applyModal"
                  onClick={() => setSelectedJob(job.title)}
                >
                  Apply
                </button>
              </div>

            </div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      <div className="modal fade" id="applyModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title ">Apply for {selectedJob}</h5>
              <button class
              Name="btn-close " data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
              <form>
                <input className="form-control mb-2" placeholder="Full Name" required />
                <input className="form-control mb-2" placeholder="Email" required />
                <input className="form-control mb-2" placeholder="Phone" required />
                <input className="form-control mb-2" value={selectedJob} readOnly />
                <input type="file" className="form-control mb-3" />
                <button className="btn btn-success w-100">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
        .custom-progress {
  height: 6px;
  background-color: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.08);
}

.custom-bar {
  width: 60%;
  background: linear-gradient(90deg, #0dcaf0, #3b82f6);
  border-radius: 10px;
  animation: loadBar 1.5s ease-in-out forwards;
  box-shadow: 0 2px 8px rgba(13, 202, 240, 0.5);
}

/* Animation */
@keyframes loadBar {
  from {
    width: 0%;
  }
  to {
    width: 60%;
  }
}
        
        `}
      </style>


    </div>
  );
}
   